"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.List = styled_components_1.default.ol(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  list-style: none;\n  text-align: center;\n  margin: 0;\n\n  & > li {\n    display: inline-block;\n  }\n"], ["\n  list-style: none;\n  text-align: center;\n  margin: 0;\n\n  & > li {\n    display: inline-block;\n  }\n"])));
var templateObject_1;